export default __webpack_public_path__ + "static/iconSprite-370807a02e71304542c0ee503cf87fbb.svg";